<div class="form__file">
  <label for="" class="label">
    <div class="astObligatoryContainer"> <span>&nbsp; </span></div>
  </label>
  <div class="decorator-container" *ngIf="state.fileName && state.status !== 'uploading'">
    <div class="check-container">
      <img src="/assets/img/icon-ok.png" class="check" alt="">
    </div>
  </div>
  <div class="decorator-container" *ngIf="state.status === 'uploading'">
    <div class="loader-container">
      <app-loader></app-loader>
    </div>
  </div>
  <input type="text" name="upload-fake"
    [placeholder]="state.status === 'uploading' ? 'Subiendo...' : state.fileName ? state.fileName  : placeholder ">
  <h6 class="form__info">
    *Formato PDF. Max {{maxFileSizeMB}} MB.
  </h6>
  <input type="file" [formControl]="realInputControlForm" accept="application/pdf" (change)="onFileSelected($event)">
  <!-- <input type="file" [formControl]="realInputControlForm" accept="image/png, image/jpeg, application/pdf" (change)="onFileSelected($event)"> -->
</div>
<app-error-message *ngIf="showErrors" [text]="state.status === 'error' ? state.description : '' ">
</app-error-message>
